import { render, staticRenderFns } from "./Operations.vue?vue&type=template&id=19973628&scoped=true&"
import script from "./Operations.vue?vue&type=script&lang=js&"
export * from "./Operations.vue?vue&type=script&lang=js&"
import style0 from "./Operations.vue?vue&type=style&index=0&id=19973628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19973628",
  null
  
)

export default component.exports